/** @format */

import {
    GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN,
    ORDER_STATUS_IN_CART,
    PRODUCT_TYPE_CARTON,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    PRODUCT_TYPE_LABEL,
    SHAPE_TYPES
} from 'frontier-constants';
import {EditModal} from './edit_item_modal';
import {prettyProductLabel, prettyProductSize} from 'frontier/ds/quoter/functions/format';
import React from 'react';
import {prettyProductShape} from '../functions/format';
import {addCommas} from 'frontier/utilities/add_comas_to_number';
import {Button, Modal, ModalFooter, ModalHeader} from '@sttark/design-system';
import {
    MODAL_EDIT,
    MODAL_UPLOAD_ARTWORK
} from '../../../cart/components/cart_overview/modal_constants';

export const AddToCart = ({order = {}, handleClose}) => {
    // check material type to set the correct property in EditModal
    // ppi (price per item)
    const ppi = () => {
        if (!order) return '';
        return order.product_type_id === PRODUCT_TYPE_LABEL ? 'pricePerLabel' : 'pricePerCarton';
    };

    let subtitle =
        order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN
            ? prettyProductLabel(
                  order.graphic_design_order_details.product_label,
                  order.product_type_id
              )
            : prettyProductLabel(order.size_description, order.product_type_id);

    // design modal and labels/ carton do not display the same data.
    // Conditionally render either.
    const addToCartProps = () => {
        if (!order) return;

        if (
            order.product_type_id === PRODUCT_TYPE_CARTON ||
            order.product_type_id === PRODUCT_TYPE_LABEL
        ) {
            return {
                material: `${order.substrate_label}`,
                laminate: `${order.laminate_label}`,
                quantity: `${addCommas(order.duplex_aware_total_qty)}`,
                designs: `${order.duplex_aware_design_qty}`,
                [ppi()]: `${
                    Math.ceil(
                        ((parseFloat(order.quoted_total) - parseFloat(order.quoted_die_charge)) /
                            order.duplex_aware_total_qty) *
                            1000
                    ) / 1000
                }`,
                itemSubtotal: `${addCommas(order.quoted_total)}`
            };
        }

        if (order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN) {
            // get shape
            let shape = SHAPE_TYPES.find(s => s.id === order.shape_id);
            shape = shape && shape.label.split(' ');
            shape = shape && shape.length > 0 && shape[0];

            shape = shape && prettyProductShape(shape, order?.is_square_corners, order.shape_id);

            // get size
            let size = prettyProductSize(
                order.size_description,
                order.product_type_id,
                order.graphic_design_order_details.design_product_type_id
            );

            // stlye property it is only available if user selects it
            let style = order.graphic_design_order_details.design_style_preferences_label;
            style = style !== '' && style !== undefined ? style : 'N/A';

            // get assToCart props based on whtehr is custom design or other
            // if it is a label
            if (order.graphic_design_order_details.design_product_type_id === 1) {
                if (
                    order.graphic_design_order_details.design_type_id ===
                    GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN
                ) {
                    return {
                        size,
                        shape,
                        color: `${order.graphic_design_order_details.color_preferences_label}`,
                        style,
                        itemSubtotal: `${order.quoted_total}`
                    };
                } else {
                    return {
                        size,
                        shape,
                        itemSubtotal: `${order.quoted_total}`
                    };
                }
            } else {
                // if it is a carton
                if (
                    order.graphic_design_order_details.design_type_id ===
                    GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN
                ) {
                    return {
                        size,
                        color: `${order.graphic_design_order_details.color_preferences_label}`,
                        style,
                        itemSubtotal: `${order.quoted_total}`
                    };
                } else {
                    return {
                        size,
                        shape,
                        itemSubtotal: `${order.quoted_total}`
                    };
                }
            }
        }
    };

    // is it a new Order or an order Edit?
    let isOrderEdit;
    isOrderEdit = location.href.split('/');
    isOrderEdit = isOrderEdit.length > 5;

    const cardBody = addToCartProps();
    return (
        <Modal onClose={handleClose} isOpen={true} zIndex={1050} bodyHeightAuto>
            <ModalHeader onClose={handleClose}>
                {isOrderEdit ? 'Item Successfully Edited' : 'Item Added to Cart'}
            </ModalHeader>
            <section>
                <div className="border-bottom border-darker pb-3">
                    <b className="font-body-bold-lg mb-2">{subtitle}</b>
                    <div style={{width: '80%'}}>
                        <div className="d-flex align-items-center justify-content-start">
                            {!!cardBody.material && (
                                <div style={{width: '50%'}}>
                                    <b className="m-0 font-body-bold-sm w-100">Material</b>
                                    <p className="w-100 m-0">{cardBody.material}</p>
                                </div>
                            )}
                            {!!cardBody.laminate && (
                                <div style={{width: '50%'}}>
                                    <b className="m-0 font-body-bold-sm w-100">Laminate</b>
                                    <p>{cardBody.laminate}</p>
                                </div>
                            )}
                        </div>
                        <div className="d-flex align-items-center justify-content-start">
                            {!!cardBody.quantity && (
                                <div style={{width: '50%'}}>
                                    <b className="m-0 font-body-bold-sm w-100">Quantity</b>
                                    <p className="w-100 m-0">{cardBody.quantity}</p>
                                </div>
                            )}
                            {!!cardBody.designs && (
                                <div style={{width: '50%'}}>
                                    <b className="m-0 font-body-bold-sm w-100">Designs</b>
                                    <p className="w-100 m-0">{cardBody.designs}</p>
                                </div>
                            )}
                        </div>
                        <div className="d-flex align-items-center justify-content-start">
                            {!!cardBody.size && (
                                <div style={{width: '50%'}}>
                                    <b className="m-0 font-body-bold-sm w-100">Size</b>
                                    <p className="w-100 m-0">{cardBody.size}</p>
                                </div>
                            )}
                            {!!cardBody.shape && (
                                <div style={{width: '50%'}}>
                                    <b className="m-0 font-body-bold-sm w-100">Shape</b>
                                    <p className="w-100 m-0">{cardBody.shape}</p>
                                </div>
                            )}
                        </div>
                        <div className="d-flex align-items-center justify-content-start">
                            {!!cardBody.color && (
                                <div style={{width: '50%'}}>
                                    <b className="m-0 font-body-bold-sm w-100">Color</b>
                                    <p className="w-100 m-0">{cardBody.color}</p>
                                </div>
                            )}
                        </div>
                    </div>
                    {!!cardBody[ppi()] && (
                        <p className="card_price-per-item text-end">
                            Price per unit:
                            <span className="font-body-bold-sm"> {cardBody[ppi()]}</span>
                        </p>
                    )}
                </div>
                <p className="card_item-subtotal mt-2 text-end font-body-bold-lg">
                    Subtotal: ${cardBody.itemSubtotal}
                </p>
            </section>
            <ModalFooter>
                <div className="d-flex align-items-center justify-content-end gap-4">
                    <Button
                        url={isOrderEdit ? '/orders/custom-labels' : '/cart'}
                        label={isOrderEdit ? 'Start New Order' : 'Go to Cart'}
                        secondary
                    />
                    <Button
                        url={isOrderEdit ? '/cart' : '/carts'}
                        label={isOrderEdit ? 'Return to Cart' : 'Checkout'}
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
};
